import { createContext, useState, useEffect, useContext } from "react";

// Tạo context
const NetworkContext = createContext();

export function NetworkProvider({ children }) {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleStatusChange = () => setIsOnline(navigator.onLine);

        window.addEventListener("online", handleStatusChange);
        window.addEventListener("offline", handleStatusChange);

        // Kiểm tra mạng mỗi 3 giây, phòng trường hợp sự kiện không kích hoạt
        const interval = setInterval(() => {
            setIsOnline(navigator.onLine);
        }, 3000);

        return () => {
            window.removeEventListener("online", handleStatusChange);
            window.removeEventListener("offline", handleStatusChange);
            clearInterval(interval);
        };
    }, []);

    return <NetworkContext.Provider value={{ isOnline }}>{children}</NetworkContext.Provider>;
}

// Custom hook để sử dụng isOnline dễ dàng
export function useNetworkStatus() {
    return useContext(NetworkContext);
}

/////////Lay lai token///////////
export const resetToken = async () => {
    let user = "";
    const userStr = window.getFromStorage("user-info");
    if (userStr === "null") return false;
    else {
        user = JSON.parse(userStr);
        const expiresAt = user.expiresAt; // timestamp (ms)
        const now = Date.now() / 1000;

        const timeLeft = expiresAt - now;

        if (timeLeft < 5 * 60 && timeLeft > 0) {
            //// khi token còn hạn 5 phút thì làm mới token
            ///console.log("Token sắp hết hạn, đang refresh...");
            const success = await refreshToken(user);

            if (!success) {
                console.warn("Refresh token thất bại. Đăng xuất người dùng...");
                localStorage.removeItem("user-info");
                window.location.href = "/logout"; // hoặc navigate("/login")
            }
        }
    }
};

// Gọi API refresh token
export const refreshToken = async (user) => {
    try {
        const res = await fetch(global.config.url.api + "refresh", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
                "user-id": user.id, // nếu bạn cần xác thực fingerprint
            },
        });

        if (!res.ok) return false;

        const ref = await res.json();

        // Giả sử backend chỉ trả về token mới (access_token)
        const newUser = {
            ...user,
            token: ref.data.access_token,
            expiresAt: ref.data.expiresAt, // hoặc server trả expiresIn, nhân vào
        };
        window.saveToStorage("user-info", JSON.stringify(newUser));
        console.log("Token đã được làm mới.");
        return true;
    } catch (err) {
        console.error("Lỗi refresh token:", err);
        return false;
    }
};
